var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransakcije(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101.91 101.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #f42f54;\n      }\n\n      .cls-3 {\n        fill: #164679;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 50.95,
    cy: 50.95,
    r: 50.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m76.05,87.05h-.38c0-2.69-2.18-4.87-4.87-4.87v-.38c2.69,0,4.87-2.18,4.87-4.87h.38c0,2.69,2.18,4.87,4.87,4.87v.38c-2.69,0-4.87,2.18-4.87,4.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.36,34.52h-.25c0-1.77-1.43-3.2-3.2-3.2v-.25c1.77,0,3.2-1.43,3.2-3.2h.25c0,1.77,1.43,3.2,3.2,3.2v.25c-1.77,0-3.2,1.43-3.2,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.66,29.09h-.56c0-3.96-3.21-7.17-7.17-7.17v-.56c3.96,0,7.17-3.21,7.17-7.17h.56c0,3.96,3.21,7.17,7.17,7.17v.56c-3.96,0-7.17,3.21-7.17,7.17Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m27.04,67.51c-8.02-11.55-6.61-27.16,3.35-37.12,9.98-9.98,25.61-11.37,37.17-3.31l-2.42,3.47c-9.88-6.89-23.24-5.69-31.77,2.84-8.51,8.51-9.72,21.85-2.87,31.72l-3.47,2.41Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "55.39 29.02 65.38 28.06 64.41 18.06 69.06 21.9 70.02 31.88 60.04 32.85 55.39 29.02"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.94,80.06c-5.77,0-11.57-1.72-16.6-5.22l2.42-3.47c9.88,6.89,23.24,5.69,31.77-2.84,8.62-8.62,9.75-22.06,2.69-31.97l3.44-2.45c8.26,11.6,6.94,27.33-3.15,37.41-5.64,5.64-13.08,8.54-20.58,8.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.52 72.89 36.53 73.85 37.5 83.84 32.85 80.01 31.88 70.02 41.87 69.06 46.52 72.89"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransakcije);
export default __webpack_public_path__ + "static/media/transakcije.5d16a500310c6c2e39e31f8251ca2b87.svg";
export { ForwardRef as ReactComponent };